module.exports = __webpack_public_path__ + "assets/img/Logo4.2c878b3a.png";